import type { WallShape } from '@walls/store';
import { getTextAttributes } from '../utils/shapeAttributes';
import { getTextSelectionBorder, measureTextShape } from '../../shapes/geometry/textGeometry';

export function drawText(
  context: CanvasRenderingContext2D,
  shape: WallShape,
  zoom: number,
  selected: boolean
) {
  const attributes = getTextAttributes(shape);
  const measured = measureTextShape(shape, context);

  context.fillStyle = attributes.color;
  context.font = measured.font;
  context.textBaseline = 'top';

  measured.lines.forEach((line, index) => {
    context.fillText(line, Math.floor(measured.x), Math.floor(measured.y + index * measured.lineHeight));
  });

  if (selected) {
    const border = getTextSelectionBorder(measured, zoom);

    context.setLineDash([0]);
    context.beginPath();
    context.rect(border.x, border.y, border.width, border.height);
    context.lineWidth = border.lineThickness;
    context.strokeStyle = '#7dc9fb';
    context.stroke();
  }
}
